import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { breakpointCodes } from 'rp-mq-breakpoints';
import DataTable from './GridDataTable';
import tableConfig from '../config/statisticsBuyersTable';
import {
    initialTableUpdate
} from '../helpers/dispatchProps';
import BuyersHeader from '../components/DataTable/StatisticsBuyersHeader';
import TableBody from '../components/DataTable/ExpandableRowsBody';
import StatisticsLots from '../components/DataTable/StatisticsLots';
import { expandRow } from '../actions/expandableRow';

const stateKey = 'statisticsBuyers';
const { EXTRA_NARROW, NARROW } = breakpointCodes;

/**
 * Container for statistics buyers view
 */
class StatisticsBuyers extends Component {
    static colSpanGetter = (breakpoint) => {
        switch (breakpoint) {
            case EXTRA_NARROW:
                return 4;
            case NARROW:
                return 6;
            default:
                return 8;
        }
    };
    getTableProps() {
        return {
            headerComponent: BuyersHeader,
            bodyComponent: TableBody,
            bodyProps: {
                expansionComponent: ({ data }) => (
                    <StatisticsLots
                        entities={data.entities}
                        colSpanGetter={StatisticsBuyers.colSpanGetter}
                    />
                ),
                expandedRow: this.props.expandedRow,
                onRowExpand: this.props.onRowExpand,
                primaryColumn: 'uid'
            }
        };
    }

    render() {
        return (
            <div className="table__StatisticsBuyers">
                <DataTable
                    config={tableConfig}
                    stateKey={stateKey}
                    errorMessage="No buyers in our records for this sale"
                    colSpanGetter={StatisticsBuyers.colSpanGetter}
                    onMount={initialTableUpdate()}
                    tableProps={this.getTableProps()}
                />
            </div>
        );
    }
}

StatisticsBuyers.propTypes = {
    /**
     * Primary column value of expanded row
     * State prop
     */
    expandedRow: PropTypes.any,
    /**
     * Expandable row onRowExpand event handler
     * Dispatch prop
     */
    onRowExpand: PropTypes.func,
};


/**
 * Create component properties based on app state
 *
 * @param {{}} state App state
 * @returns {{}} Properties
 */
function mapStateToProps(state) {
    const { expandedRow } = state[stateKey].expandableRow;
    return {
        expandedRow,
    };
}

/**
 * Create component callable properties
 *
 * @returns {{}} Properties
 */
function mapDispatchToProps(dispatch) {
    return {
        onRowExpand(rowIndex) {
            dispatch(expandRow(stateKey, rowIndex));
        }
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(StatisticsBuyers);



// WEBPACK FOOTER //
// ./src/js/containers/StatisticsBuyers.js